import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { SidenavComponent } from '../../components/sidenav/sidenav.component';
import { SiteConfigStore } from '@program-suite/data-common';
import { FooterComponent } from "../../components/footer/footer.component";
import { SpinnerStore } from '@program-suite/data-common';
import { LoadingSpinnerComponent } from '../../components/loading-spinner/loading-spinner.component';
import { BannerComponent } from "../../components/banner/banner.component";
@Component({
  selector: 'lib-logged-in',
  imports: [CommonModule, RouterModule, SidenavComponent, FooterComponent, LoadingSpinnerComponent, BannerComponent],
  templateUrl: './logged-in.component.html',
  styleUrl: './logged-in.component.scss',
})
export class LoggedInComponent {
  siteConfigStore = inject(SiteConfigStore);
  spinnerStore = inject(SpinnerStore);
  siteConfig = this.siteConfigStore.siteConfig();
  siteName = this.siteConfigStore.siteConfig()?.name ?? '';
  logoSrc = signal<string>(this.siteConfig?.logoUrl ?? '');
  iconSrc = signal<string>(this.siteConfig?.iconUrl ?? '');
  loggedInRoutes: any  = [];

  constructor(private router: Router) {
     this.extractLoggedInRoutes();
  }
    
  private extractLoggedInRoutes() {
    const loggedInRoute = this.router.config.find(route => route.component === LoggedInComponent);
    if (loggedInRoute && loggedInRoute.children) {
      this.loggedInRoutes = loggedInRoute.children;
    }
  }
}